// Pedido manual "entrega + 100" (Adnéia, 28/10/2026). Quem sobe o reenvio à mão no BSeller
// numera o pedido com a entrega original e "100" no fim (128468767 -> 128468767100), e o pedido
// novo não leva o número do canal. O backend liga o reenvio à entrega de origem na hora da busca
// (reenvio_manual_de) e traz o número do canal do pedido original (pedido_externo_origem).

function texto(valor) {
  return String(valor ?? '').trim();
}

// O número do pedido no cabeçalho do card: o do canal; no manual, o do canal do pedido original;
// sem nenhum dos dois, o pedido_cliente, para o cabeçalho nunca ficar sem referência (Adnéia 17/09).
export function pedidoDoCabecalho(pedido) {
  if (!pedido) return null;
  const externo = texto(pedido.pedido_externo);
  if (externo) return { numero: externo, manual: false, reenvioDe: '' };
  const numero = texto(pedido.pedido_externo_origem) || texto(pedido.pedido_cliente);
  if (!numero) return null;
  return { numero, manual: true, reenvioDe: texto(pedido.reenvio_manual_de) };
}

// A linha do quadro "Selecione o Pedido" que diz de onde veio o reenvio manual.
export function linhaReenvio(pedido) {
  const origem = texto(pedido?.reenvio_manual_de);
  return origem ? `Reenvio manual da entrega #${origem}` : '';
}
